<template>
  <div class="mb-5 pb-5">
    <div class="row mt-4">
      <div class="col-12 col-sm-6 col-md-2">
        <Select
          label="Ano"
          name="ano"
          v-model="filters.ano"
          :options="anos"
          classe="col-13"
        />
      </div>
      <div class="col-12 col-sm-6 col-md-3">
        <Select
          label="Mês"
          name="mes"
          v-model="filters.mes"
          :options="meses"
          classe="col-13"
        />
      </div>
      <div class="col-12 col-sm-6 col-md-3">
        <Select
          label="Status"
          name="status"
          v-model="filters.status"
          :options="status"
          classe="col-13"
        />
      </div>
      <div class="col-12 col-sm-6 col-md-2" v-if="contas.length > 0">
        <Select
          label="Conta"
          name="conta"
          v-model="filters.conta"
          :options="contas"
          classe="col-13"
        />
      </div>
      <div class="col-12 col-sm-6 col-md-4 filter-buttons">
        <button
          type="button"
          class="btn btn-success btn-sm"
          @click="filtrar"
        >
          <Icon
            type="fas"
            icon="search"
            color="white"
          />
        </button>
        <button
          type="button"
          class="btn btn-cancel btn-sm"
          @click="limpar"
        >
          <Icon
            type="fas"
            icon="times"
            title="Limpar"
          />
        </button>
      </div>
    </div>

    <div class="row mt-4" v-if="!filtrou && !loading">
      <div class="col-12 col-sm-12 col-md-12 col-lg-6">
        <div class="alert alert-info small">
          <i class="fas fa-info-circle mr-1"></i>
          Utilize o formulário para buscar um relatório do mês desejado.
        </div>
      </div>
    </div>

    <div class="row mt-4" v-show="filtrou && !loading">
      <DataTable
        name="Relatório de Faturas Iugu"
        :headers="headers"
        :data="tableData"
        :pesquisa="true"
      >
        <template v-slot:[`item.cliente`]="{ item }">
          <span v-if="item.customer_name">
            {{ item.customer_name }} <br />
            <small>{{ item.customer_email }}</small>
          </span>
          <span v-else>
            {{ item.customer_email }}
          </span>
        </template>

        <template v-slot:[`item.valor`]="{ item }">
          {{ formatNumber(item.valor) }}
        </template>

        <template v-slot:[`item.taxas`]="{ item }">
          {{ formatNumber(item.taxas) }}
        </template>

        <template v-slot:[`item.comissao`]="{ item }">
          {{ formatNumber(item.comissao) }}
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <span
            class="tag-status font-weight-bold"
            :class="getStatusClass(item.status)"
          >
            {{ getStatusLabel(item.status) }}
          </span>
        </template>

        <template v-slot:[`item.negocio`]="{ item }">
          <a
            v-if="item.btnNegocio"
            :href="getNegocioUrl(item)"
            target="_blank"
            class="btn btn-sm btn-primary btn-depth mr-1"
          >
            <Icon
              type="fas"
              icon="external-link-alt"
              color="white"
            />
            {{ item.btnNegocio }}
          </a>
        </template>

        <template v-slot:[`item.fatura`]="{ item }">
          <a
            v-if="item.urlFatura"
            :href="item.urlFatura"
            target="_blank"
            class="btn btn-sm btn-primary btn-depth mr-1"
          >
            <Icon
              type="fas"
              icon="external-link-alt"
              color="white"
            />
            Abrir
          </a>
        </template>
      </DataTable>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment';
import axios from "axios";

import Icon from '../ui/Icon.vue';
import Select from '../ui/Select.vue';
import DataTable from '../ui/DataTable.vue';

export default {
  name: 'RelatorioFaturasIugu',
  components: {
    Icon,
    Select,
    DataTable,
  },
  props: {
    anos: {
      type: Array,
      required: true,
    },
    meses: {
      type: Array,
      required: true,
    },
    status: {
      type: Array,
      required: true,
    },
    contas: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const anoAtual = moment().format('YYYY');
    const mesAtual = moment().format('MM');
    
    return {
      filtrou: false,
      loading: false,
      filters: {
        ano: this.anos.find(a => a.id == anoAtual) || null,
        mes: this.meses.find(m => m.id == mesAtual) || null,
        status: this.status.find(s => s.id == '') || null,
        conta: null,
      },
      data: {
        total: 0,
        results: [],
      },
      headers: [
        {
          text: 'Cliente',
          value: 'cliente',
        },
        {
          text: 'Valor',
          value: 'valor',
          align: 'right',
          total: true,
          precision: 2,
        },
        {
          text: 'Taxas',
          value: 'taxas',
          align: 'right',
          total: true,
          precision: 2,
        },
        {
          text: 'Comissão',
          value: 'comissao',
          align: 'right',
          total: true,
          precision: 2,
        },
        {
          text: 'Status',
          value: 'status',
        },
        {
          text: 'Emissão',
          value: 'emissao',
        },
        {
          text: 'Vencimento',
          value: 'vencimento',
        },
        {
          text: 'Pagamento',
          value: 'pagamento',
        },
        {
          text: 'Recebimento',
          value: 'recebimento',
        },
        {
          text: 'Id Negócio',
          value: 'idNegocio',
        },
        {
          text: 'Negócio',
          value: 'negocio',
        },
        {
          text: 'Fatura',
          value: 'fatura',
        },
        {
          text: 'Iugu ID',
          value: 'iuguId',
        },
      ],
    };
  },
  computed: {
    tableData() {
      return this.data.results.map(item => ({
        cliente: item.customer_name || item.customer_email,
        customer_name: item.customer_name,
        customer_email: item.customer_email,
        valor: parseFloat(this.removeCurrency(item.paid_value)) || 0,
        taxas: parseFloat(this.removeCurrency(item.taxes_paid)) || 0,
        comissao: parseFloat(this.removeCurrency(item.commission)) || 0,
        status: item.status,
        emissao: this.formatDate(item.created_at),
        vencimento: this.formatDate(item.due_date, 'date'),
        pagamento: item.paid_at ? this.formatDate(item.paid_at) : '',
        recebimento: item.receivable_date ? this.formatDate(item.receivable_date) : '',
        idNegocio: item.idNegocio || '',
        btnNegocio: item.btnNegocio,
        tipoNegocio: item.tipoNegocio,
        urlFatura: item.urlFatura,
        iuguId: item.id,
        _raw: item, // Para manter os dados originais se necessário
      }));
    },
  },
  methods: {
    limpar() {
      const anoAtual = moment().format('YYYY');
      const mesAtual = moment().format('MM');
      
      this.filters = {
        ano: this.anos.find(a => a.id == anoAtual) || null,
        mes: this.meses.find(m => m.id == mesAtual) || null,
        status: this.status.find(s => s.id == '') || null,
        conta: null,
      };
      this.filtrou = false;
      this.data = {
        total: 0,
        results: [],
      };
    },
    async filtrar() {
      this.loading = true;
      $("#overlayer-loading").addClass("show-overlayer");

      const params = {
        ano: this.filters.ano ? this.filters.ano.id : moment().format('YYYY'),
        mes: this.filters.mes ? this.filters.mes.id : moment().format('MM'),
      };

      if (this.filters.status && this.filters.status.id) {
        params.status = this.filters.status.id;
      }

      if (this.filters.conta && this.filters.conta.id) {
        params.conta = this.filters.conta.id;
      }

      await api.get('/painel/faturas-iugu/relatorio', { params })
        .then(async response => {
          if (response.data.url) {
            const retorno_url = await axios.get(response.data.url, {
              withCredentials: false,
            });
            this.data = retorno_url.data;
          } else {
            this.data = response.data.data;
          }
          this.filtrou = true;
        })
        .catch(error => {
          let errorMessage = 'Erro ao buscar relatório de faturas';
          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          }
          if (error.response && error.response.data && error.response.data.errors) {
            Object.values(error.response.data.errors).forEach(item => {
              errorMessage = errorMessage.concat('</br>', item);
            });
          }
          window.showToastDanger('body', errorMessage);
        })
        .finally(() => {
          this.loading = false;
          $("#overlayer-loading").removeClass("show-overlayer");
        });
    },
    formatCurrency(value) {
      if (!value) return '0,00';
      return value.toString().replace('R$ ', '');
    },
    removeCurrency(value) {
      if (!value) return '0';
      return value.toString().replace('R$ ', '').replace(/\./g, '').replace(',', '.');
    },
    formatNumber(value) {
      return value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    formatDate(date, type = 'datetime') {
      if (!date) return '';
      if (type === 'date') {
        return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
      }
      return moment(date).format('DD/MM/YYYY HH:mm');
    },
    getStatusLabel(status) {
      const statusItem = this.status.find(s => s.id === status);
      return statusItem ? statusItem.value : status;
    },
    getStatusClass(status) {
      if (status === 'paid') return 'text-success';
      if (status === 'pending') return 'text-warning';
      if (status === 'canceled') return 'text-danger';
      return '';
    },
    getNegocioUrl(item) {
      if (!item.tipoNegocio || !item.idNegocio) return '#';
      return `/painel/${item.tipoNegocio}/${item.idNegocio}`;
    },
  },
}
</script>
